import { Link } from "react-router-dom";
import { useSite } from "../lib/store";
import { Markdown, Dots } from "../components/Bits";
import { useSeo } from "../components/Seo";

export default function ContentPage({ textKey, title, notFound }) {
  const { site } = useSite();
  const [g0, k0] = textKey?.startsWith("legal.") ? ["legal", textKey.slice(6)] : ["texts", textKey];
  useSeo({ title, description: notFound ? "" : site?.[g0]?.[k0], noindex: !!notFound });
  if (!site) return <div className="h-[60vh]" />;
  const [grp, key] = textKey?.startsWith("legal.") ? ["legal", textKey.slice(6)] : ["texts", textKey];
  const text = notFound ? "" : site[grp]?.[key] || "";
  return (
    <div data-testid={`content-page-${(textKey || "404").replace(".", "-")}`}>
      <section className="relative paper overflow-hidden">
        <Dots />
        <div className="max-w-4xl mx-auto px-6 py-16 relative">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold"><span className="squiggle">{title}</span></h1>
        </div>
      </section>
      <div className="max-w-3xl mx-auto px-6 py-10">
        {notFound ? <p className="font-hand text-2xl">Tahle stránka se někam zatoulala. <Link to="/" className="underline">Zpět domů</Link></p> : <Markdown text={text} />}
      </div>
    </div>
  );
}
